export function customTypeChecker(validate, expectedMsg, required) {
  return (props, propName, componentName, location) => {
    const propValue = props[propName];

    if (required && (typeof propValue === "undefined" || propValue === null)) {
      return new Error(
        `The prop ${location} \`${propName}\` is marked as required` +
          ` in \`${componentName}\`, but its value is \`${typeof propValue === "undefined" ? "undefined" : "null"}\`.`,
      );
    }

    if (!validate(propValue)) {
      return new Error(
        `Invalid ${location} \`${propName}\` of \`${propValue}\` supplied to` +
          ` \`${componentName}\`, expected \`${expectedMsg}\``,
      );
    }
  };
}
